export class EnvironmentPreset {
    fontName: string;
    fontSize: number;
    tinyEditor: boolean;
    angularEditor: boolean;
    startLocalPacsClient: boolean;
    isCT: boolean;
}
